<template>
  <div>
  <Block01v2
    :scrollIndicator="true"
    :imageUrlRightWebp="KeyshotLandingHeroWebp"
    :imageUrlRightJpeg="KeyshotLandingHeroJpeg"
    :imageUrlBelowWebp="KeyshotLandingHeroWebp"
    :imageUrlBelowJpeg="KeyshotLandingHeroJpeg"
    :alt="$t('viewer-3d-ar.block01.alt')"
  >
    <template #title>
      <div class="mt-8 xl:mt-0 text-highlight" style="text-shadow:0 0 4px white;">
          <span class="font-smaller">{{ $t('viewer-3d-ar.block01.title_1') }} </span>{{ $t('viewer-3d-ar.block01.title_2') }}<br>
          <span class="whitespace-nowrap"><span class="font-smaller">{{ $t('viewer-3d-ar.block01.title_3') }}</span> {{ $t('viewer-3d-ar.block01.title_4') }}</span><span class="">?</span>
          <br><span>{{ $t('viewer-3d-ar.block01.title_5') }}</span><span class="">,</span>
          <br><span class="font-smaller">{{ $t('viewer-3d-ar.block01.title_6') }}</span> <span class="whitespace-nowrap">{{ $t('viewer-3d-ar.block01.title_7') }}</span><span class="">!</span>
        </div>
        </template>
  </Block01v2>

  <Block2Cols>
    <template #col1>
      <MARSTitle>{{ $t('viewer-3d-ar.block2cols1.col1') }}</MARSTitle>
    </template>
    <template #col2>
      <p v-html="$t('viewer-3d-ar.block2cols1.col2.text1')" />
      <p>{{ $t('viewer-3d-ar.block2cols1.col2.text2') }}</p>
    </template>
  </Block2Cols>

  <Block2Cols compact>
    <template #col1>
      <!-- Mobile dropdown -->
      <div class="md:hidden">
        <label for="tabs" class="sr-only">{{ $t('viewer-3d-ar.block2cols2.selectPlatform') }}</label>
        <!-- Use an "onChange" listener to redirect the user to the selected tab URL. -->
        <select id="tabs" name="tabs"
                class="block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-highlight focus:outline-none focus:ring-highlight sm:text-sm"
                @change="platformSelected"
        >
          <option v-for="(tab, id) in webViewerTabs" :key="tab.name" :value="id" :selected="webViewerCurrentTabId == id">{{ $t(tab.name).toString() }}</option>
        </select>
      </div>
      <!-- Desktop tabs -->
      <div class="hidden md:block mb-1">
        <p>{{ $t('viewer-3d-ar.block2cols2.selectPlatform') }}</p>
        <div class="border-b border-gray-200">
          <nav class="-mb-px flex space-x-8" aria-label="Tabs">
            <a v-for="(tab, id) in webViewerTabs" :key="tab.name"
               :class="[id === webViewerCurrentTabId ? 'border-highlight text-highlight' : 'border-transparent text-gray-500 hover:border-darkgray hover:text-darkgray cursor-pointer', 'whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium']"
               @click="userInput.userSelectedTabId = id">{{ $t(tab.name).toString() }}
            </a>
          </nav>
        </div>
      </div>
      <!-- video and info-->
      <!-- <div style="max-height: 550px; overflow: hidden; overflow-y: scroll;"> -->
      <div v-for="(info, id) in webViewerTabs[webViewerCurrentTabId].info" :key="id"
           class="flex flex-col-reverse sm:flex-row text-sm" :class="{'pt-2 mt-2 border-t' : id > 0, 'mt-4': id ==0}">
        <video :src="info.videoUrl" style="height: 150px; max-height: 150px; border: 1px solid #fafafa;" autoplay loop muted playsinline font-small />
        <div>
          <p class="pl-4">{{ $t(info.title).toString() }}</p>
          <ul>
            <li v-for="(text, sid) in $tm(info.text)" :key="sid" class="list-inside list-disc text-sm">
              {{ $rt(text).toString() }}
            </li>
          </ul>
        </div>
      </div>
    </template> <!-- /col1 -->
    <template #col2>
      <div class="w-full h-iframeContainer md:h-iframeContainerMd relative viewer3d mt-10" style="min-height: 880px;">
        <div class="absolute top-0 bottom-0 left-0 right-0 sketched-bkg" />
        <img loading="lazy" class="absolute top-0 left-0" style="width: 200px;" :src="localizedImage" :alt="$t('viewer-3d-ar.image_alt.block2cols2.backgroundImage')">
        <iframe loading="lazy"
          allow="xr-spatial-tracking *;fullscreen *; web-share *"
          allowfullscreen allowtransparency="true"
          title="My AR Studio Universal Viewer: 3D only viewer of a coffee maker."
          class="relative"
          style="width:100%; height:100%;"
          src="https://cdn.myarstudio.cloud/f2f01834-6984-4e4d-bd20-8e7586523cf0/Playground/Products/86d6b5d1-ed63-5a2d-8018-f214d5c3fc41/default/fe44c9a6-e0be-52e7-89bb-9320010337fe/index.html?hideui=y"                
        />
      </div>
    </template>
  </Block2Cols>

  <Block2Cols>
    <template #col1>
      <MARSTitle><span class="whitespace-nowrap">{{ $t('viewer-3d-ar.block2cols3.col1.title1') }}</span>,<br />
          <span>{{ $t('viewer-3d-ar.block2cols3.col1.title2') }}</span></MARSTitle>
    </template>
    <template #col2>
      <p v-html="$t('viewer-3d-ar.block2cols3.col2.text1')" />
      <p>{{ $t('viewer-3d-ar.block2cols3.col2.text2') }}</p>
    </template>
  </Block2Cols>

  <Block2Cols>
    <template #col1>
      <MARSTitle>{{ $t('viewer-3d-ar.block2cols4.col1.title') }}</MARSTitle>
      <p>{{ $t('viewer-3d-ar.block2cols4.col1.text1') }}</p>
      <p>{{ $t('viewer-3d-ar.block2cols4.col1.text2') }}</p>
    </template>
    <template #col2>
      <video class="fullscreen block" src="~/assets/video/landing/WhatIsARMobile.mp4#t=0.1" controls muted loop playsinline preload />
    </template>
  </Block2Cols>

  <Block2Cols compact class="mt-8">
    <template #col1>
      <h3>{{ $t('viewer-3d-ar.block2cols5.title') }}</h3>
    </template>
  </Block2Cols>

  <Block2Cols compact class="mt-8">
    <template #col1>
      <div class="flex flex-col-reverse sm:flex-row gap-4 items-center">
        <div>
          <picture>
            <source type="image/webp" srcset="~/assets/img/landing/WhatIsARMobile_step1.webp">
            <source type="image/jpeg" srcset="~/assets/img/landing/WhatIsARMobile_step1.jpg">
            <img loading="lazy" style="width: 200px; min-width: 200px;" src="~/assets/img/landing/WhatIsARMobile_step1.jpg" :alt="$t('viewer-3d-ar.image_alt.block2cols6.step1')">
          </picture>
        </div>
        <p>{{ $t('viewer-3d-ar.block2cols6.steps.step1') }}</p>
      </div>
    </template>
    <template #col2>
      <div class="flex flex-col-reverse sm:flex-row gap-4 items-center">
        <div>
          <picture>
            <source type="image/webp" srcset="~/assets/img/landing/WhatIsARMobile_step2.webp">
            <source type="image/jpeg" srcset="~/assets/img/landing/WhatIsARMobile_step2.jpg">
            <img loading="lazy" style="width: 200px; min-width: 200px;" src="~/assets/img/landing/WhatIsARMobile_step2.jpg" :alt="$t('viewer-3d-ar.image_alt.block2cols6.step2')">
          </picture>
        </div>
        <p>{{ $t('viewer-3d-ar.block2cols6.steps.step2') }}</p>
      </div>
    </template>
  </Block2Cols>
  <Block2Cols compact class="mt-8">
    <template #col1>
      <div class="flex flex-col-reverse sm:flex-row gap-4 items-center">
        <div>
          <picture>
            <source type="image/webp" srcset="~/assets/img/landing/WhatIsARMobile_step3.webp">
            <source type="image/jpeg" srcset="~/assets/img/landing/WhatIsARMobile_step3.jpg">
            <img loading="lazy" style="width: 200px; min-width: 200px;" src="~/assets/img/landing/WhatIsARMobile_step3.jpg" :alt="$t('viewer-3d-ar.image_alt.block2cols6.step3')">
          </picture>
        </div>
        <p>{{ $t('viewer-3d-ar.block2cols6.steps.step3') }}</p>
      </div>
    </template>
    <template #col2>
      <div class="flex flex-col-reverse sm:flex-row gap-4 items-center">
        <div>
          <picture>
            <source type="image/webp" srcset="~/assets/img/landing/WhatIsARMobile_step4.webp">
            <source type="image/jpeg" srcset="~/assets/img/landing/WhatIsARMobile_step4.jpg">
            <img loading="lazy" style="width: 200px; min-width: 200px;" src="~/assets/img/landing/WhatIsARMobile_step4.jpg" :alt="$t('viewer-3d-ar.image_alt.block2cols6.step4')">
          </picture>
        </div>
        <p>{{ $t('viewer-3d-ar.block2cols6.steps.step4') }}</p>
      </div>
    </template>
  </Block2Cols>
  <Block2Cols compact class="mt-8">
    <template #col1>
      <h3>{{ $t('viewer-3d-ar.block2cols7.resultTitle') }}</h3>
      <p v-html="$t('viewer-3d-ar.block2cols7.resultText')"></p>
    </template>
    <template #col2 />
  </Block2Cols>
  <Block2Cols>
    <template #col1>
      <MARSTitle>{{ $t('viewer-3d-ar.block2cols8.title') }}</MARSTitle>
      <p>{{ $t('viewer-3d-ar.block2cols8.text') }}</p>
    </template>
    <template #col2>
      <video class="fullscreen block" src="~/assets/video/landing/WhatIsARDesktop.mp4#t=0.1" controls muted loop playsinline preload />
    </template>
  </Block2Cols>

  <Block1Col compact class="mt-8">
    <p>{{ $t('viewer-3d-ar.block1col1.text') }}</p>
    <img loading="lazy" style="min-height: 200px" class="block w-full" src="~/assets/img/landing/Final User workflow.svg" :alt="$t('viewer-3d-ar.image_alt.block1col.finalWorkflow')">
  </Block1Col>
  <Block2Cols compact class="mt-8">
    <template #col1>
      <div class="flex flex-col-reverse sm:flex-row gap-4 items-center">
        <div>
          <picture>
            <source type="image/webp" srcset="~/assets/img/landing/WhatIsARDesktop_step1.webp">
            <source type="image/jpeg" srcset="~/assets/img/landing/WhatIsARDesktop_step1.jpg">
            <img loading="lazy" style="width: 200px; min-width: 200px;" src="~/assets/img/landing/WhatIsARDesktop_step1.jpg" :alt="$t('viewer-3d-ar.image_alt.block2cols9.step1')">
          </picture>
        </div>
        <p>{{ $t('viewer-3d-ar.block2cols9.steps.step1') }}</p>
      </div>
    </template>
    <template #col2>
      <div class="flex flex-col-reverse sm:flex-row gap-4 items-center">
        <div>
          <picture>
            <source type="image/webp" srcset="~/assets/img/landing/WhatIsARDesktop_step2.webp">
            <source type="image/jpeg" srcset="~/assets/img/landing/WhatIsARDesktop_step2.jpg">
            <img loading="lazy" style="width: 200px; min-width: 200px;" src="~/assets/img/landing/WhatIsARDesktop_step2.jpg" :alt="$t('viewer-3d-ar.image_alt.block2cols9.step2')">
          </picture>
        </div>
        <p>{{ $t('viewer-3d-ar.block2cols9.steps.step2') }}</p>
      </div>
    </template>
  </Block2Cols>
  <Block2Cols compact class="mt-8">
    <template #col1>
      <div class="flex flex-col-reverse sm:flex-row gap-4 items-center">
        <div>
          <picture>
            <source type="image/webp" srcset="~/assets/img/landing/WhatIsARDesktop_step3.webp">
            <source type="image/jpeg" srcset="~/assets/img/landing/WhatIsARDesktop_step3.jpg">
            <img loading="lazy" style="width: 200px; min-width: 200px;" src="~/assets/img/landing/WhatIsARDesktop_step3.jpg" :alt="$t('viewer-3d-ar.image_alt.block2cols9.step3')">
          </picture>
        </div>
        <p>{{ $t('viewer-3d-ar.block2cols9.steps.step3') }}</p>
      </div>
    </template>
    <template #col2>
      <div class="flex flex-col-reverse sm:flex-row gap-4 items-center">
        <div>
          <picture>
            <source type="image/webp" srcset="~/assets/img/landing/WhatIsARDesktop_step4.webp">
            <source type="image/jpeg" srcset="~/assets/img/landing/WhatIsARDesktop_step4.jpg">
            <img loading="lazy" style="width: 200px; min-width: 200px;" src="~/assets/img/landing/WhatIsARDesktop_step4.jpg" :alt="$t('viewer-3d-ar.image_alt.block2cols9.step4')">
          </picture>
        </div>
        <p>{{ $t('viewer-3d-ar.block2cols9.steps.step4') }}</p>
      </div>
    </template>
  </Block2Cols>
  <Block2Cols compact class="mt-8">
    <template #col1>
      <div class="flex flex-col-reverse sm:flex-row gap-4 items-center">
        <div>
          <picture>
            <source type="image/webp" srcset="~/assets/img/landing/WhatIsARDesktop_step5.webp">
            <source type="image/jpeg" srcset="~/assets/img/landing/WhatIsARDesktop_step5.jpg">
            <img loading="lazy" style="width: 200px; min-width: 200px;" src="~/assets/img/landing/WhatIsARDesktop_step5.jpg" :alt="$t('viewer-3d-ar.image_alt.block2cols9.step5')">
          </picture>
        </div>
        <p>{{ $t('viewer-3d-ar.block2cols9.steps.step5') }}</p>
      </div>
    </template>
    <template #col2>
      <div class="flex flex-col-reverse sm:flex-row gap-4 items-center">
        <div>
          <picture>
            <source type="image/webp" srcset="~/assets/img/landing/WhatIsARDesktop_step6.webp">
            <source type="image/jpeg" srcset="~/assets/img/landing/WhatIsARDesktop_step6.jpg">
            <img loading="lazy" style="width: 200px; min-width: 200px;" src="~/assets/img/landing/WhatIsARDesktop_step6.jpg" :alt="$t('viewer-3d-ar.image_alt.block2cols9.step6')">
          </picture>
        </div>
        <p>{{ $t('viewer-3d-ar.block2cols9.steps.step6') }}</p>
      </div>
    </template>
  </Block2Cols>

  <Block2Cols>
    <template #col1>
      <MARSTitle>{{ $t('viewer-3d-ar.block2cols10.title') }}</MARSTitle>
      <p v-html="$t('viewer-3d-ar.block2cols10.text')"></p>
      <div class="pt-8 flex items-center gap-4">
        <div>
          <p v-html="$t('viewer-3d-ar.block2cols10.actionButtonText')"></p>
        </div>
        <div style="width: 70px;">
          <picture>
            <source type="image/webp" srcset="~/assets/img/universal-viewer-action-button.webp">
            <source type="image/png" srcset="~/assets/img/universal-viewer-action-button.png">
            <img loading="lazy" style="height: 58px; width: 58px;" src="~/assets/img/universal-viewer-action-button.png" :alt="$t('viewer-3d-ar.image_alt.block2cols10.actionButton')">
          </picture>
        </div>
      </div>
      <p class="pt-8">{{ $t('viewer-3d-ar.block2cols10.rememberText') }}</p>
      <ul>
        <li v-html="$t('viewer-3d-ar.block2cols10.desktopText')"></li>
        <li v-html="$t('viewer-3d-ar.block2cols10.mobileText')"></li>
      </ul>
      <p>{{ $t('viewer-3d-ar.block2cols10.finalText') }}</p>
    </template>
    <template #col2>
      <div class="w-full h-iframeContainer md:h-iframeContainerMd lg:mt-0 relative viewer3d" style="min-height: 720px;">
        <picture>
          <source type="image/webp" srcset="~/assets/img/landing/MyARStudioUniversalViewerHandwriting.webp">
          <source type="image/png" srcset="~/assets/img/landing/MyARStudioUniversalViewerHandwriting.png">
          <img loading="lazy" class="absolute top-0 left-0" style="width: 200px;" src="~/assets/img/landing/MyARStudioUniversalViewerHandwriting.png" :alt="$t('viewer-3d-ar.image_alt.block2cols10.backgroundImage')">
        </picture>
        <iframe loading="lazy"
          allow="xr-spatial-tracking *;fullscreen *; web-share *"
          allowfullscreen allowtransparency="true"
          title="My AR Studio Universal Viewer: 3D and AR viewer of a coffee maker."
          class="relative"
          style="width:100%; height:100%;"
          :src="'https://cdn.myarstudio.cloud/f2f01834-6984-4e4d-bd20-8e7586523cf0/Playground/Products/86d6b5d1-ed63-5a2d-8018-f214d5c3fc41/default/fe44c9a6-e0be-52e7-89bb-9320010337fe/index.html?language=' + $i18n.locale"
        />
      </div>
    </template>
  </Block2Cols>
  </div>
</template>


<script lang="ts" setup>
import KeyshotLandingHeroWebp from '~/assets/img/landing/KeyshotLandingHero.webp'
import KeyshotLandingHeroJpeg from '~/assets/img/landing/KeyshotLandingHero.jpg'

import ViewerMouseRotate from '~/assets/video/landing/ViewerMouseRotate.mp4';
import ViewerMouseZoom from '~/assets/video/landing/ViewerMouseZoom.mp4';
import ViewerMouseScroll from '~/assets/video/landing/ViewerMouseScroll.mp4';
import ViewerMousePan from '~/assets/video/landing/ViewerMousePan.mp4';
import ViewerMouseReset from '~/assets/video/landing/ViewerMouseReset.mp4';

import ViewerLaptopRotate from '~/assets/video/landing/ViewerLaptopRotate.mp4';
import ViewerLaptopZoom from '~/assets/video/landing/ViewerLaptopZoom.mp4';
import ViewerLaptopScroll from '~/assets/video/landing/ViewerLaptopScroll.mp4';
import ViewerLaptopPan from '~/assets/video/landing/ViewerLaptopPan.mp4';
import ViewerLaptopReset from '~/assets/video/landing/ViewerLaptopReset.mp4';

import ViewerMobileRotate from '~/assets/video/landing/ViewerMobileRotate.mp4';
import ViewerMobileZoom from '~/assets/video/landing/ViewerMobileZoom.mp4';
import ViewerMobileScroll from '~/assets/video/landing/ViewerMobileScroll.mp4';
import ViewerMobilePan from '~/assets/video/landing/ViewerMobilePan.mp4';
import ViewerMobileReset from '~/assets/video/landing/ViewerMobileReset.mp4';

import ThisIsAWeb3DViewer_en from '~/assets/img/landing/ThisIsA3DWebViewerHandwriting_en.webp'
import ThisIsAWeb3DViewer_it from '~/assets/img/landing/ThisIsA3DWebViewerHandwriting_it.webp'
import ThisIsAWeb3DViewer_de from '~/assets/img/landing/ThisIsA3DWebViewerHandwriting_de.webp'


import { useRoute } from 'vue-router';

// Access the current route
const route = useRoute();
const { locale } = useI18n()

// Types for global window object
declare global {
  interface Window {
    hj: any;
    _hjSettings: any;
  }
}

// SubjectType definition
const SubjectType = {
  GENERIC: 'generic',
  KEYSHOT: 'keyshot',
};

// Reactive state
const env = process.env;
const userInput = reactive({
  isTouch: false,
  isTrackpad: false,
  isMouse: false,
  trackpadHit: 0,
  mouseHit: 0,
  userSelectedTabId: -1,
});

const webViewerTabs = [
  {
    name: 'viewer-3d-ar.webViewerTabs.desktop.name',
    info: [
      {
        videoUrl: ViewerMouseRotate,
        title: 'viewer-3d-ar.webViewerTabs.desktop.rotate.title',
        text: 'viewer-3d-ar.webViewerTabs.desktop.rotate.text'
      },
      {
        videoUrl: ViewerMouseZoom,
        title: 'viewer-3d-ar.webViewerTabs.desktop.zoom.title',
        text: 'viewer-3d-ar.webViewerTabs.desktop.zoom.text'
      },
      {
        videoUrl: ViewerMouseScroll,
        title: 'viewer-3d-ar.webViewerTabs.desktop.scroll.title',
        text: 'viewer-3d-ar.webViewerTabs.desktop.scroll.text'
      },
      {
        videoUrl: ViewerMousePan,
        title: 'viewer-3d-ar.webViewerTabs.desktop.pan.title',
        text: 'viewer-3d-ar.webViewerTabs.desktop.pan.text'
      },
      {
        videoUrl: ViewerMouseReset,
        title: 'viewer-3d-ar.webViewerTabs.desktop.reset.title',
        text: 'viewer-3d-ar.webViewerTabs.desktop.reset.text'
      }
    ]
  },
  {
    name: 'viewer-3d-ar.webViewerTabs.laptop.name',
    info: [
      {
        title: 'viewer-3d-ar.webViewerTabs.laptop.rotate.title',
        videoUrl: ViewerLaptopRotate,
        text: 'viewer-3d-ar.webViewerTabs.laptop.rotate.text'
      },
      {
        title: 'viewer-3d-ar.webViewerTabs.laptop.zoom.title',
        videoUrl: ViewerLaptopZoom,
        text: 'viewer-3d-ar.webViewerTabs.laptop.zoom.text'
      },
      {
        title: 'viewer-3d-ar.webViewerTabs.laptop.scroll.title',
        videoUrl: ViewerLaptopScroll,
        text: 'viewer-3d-ar.webViewerTabs.laptop.scroll.text'
      },
      {
        title: 'viewer-3d-ar.webViewerTabs.laptop.pan.title',
        videoUrl: ViewerLaptopPan,
        text: 'viewer-3d-ar.webViewerTabs.laptop.pan.text'
      },
      {
        title: 'viewer-3d-ar.webViewerTabs.laptop.reset.title',
        videoUrl: ViewerLaptopReset,
        text: 'viewer-3d-ar.webViewerTabs.laptop.reset.text'
      }
    ]
  },
  {
    name: 'viewer-3d-ar.webViewerTabs.mobile.name',
    info: [
      {
        title: 'viewer-3d-ar.webViewerTabs.mobile.rotate.title',
        videoUrl: ViewerMobileRotate,
        text: 'viewer-3d-ar.webViewerTabs.mobile.rotate.text'
      },
      {
        title: 'viewer-3d-ar.webViewerTabs.mobile.zoom.title',
        videoUrl: ViewerMobileZoom,
        text: 'viewer-3d-ar.webViewerTabs.mobile.zoom.text'
      },
      {
        title: 'viewer-3d-ar.webViewerTabs.mobile.scroll.title',
        videoUrl: ViewerMobileScroll,
        text: 'viewer-3d-ar.webViewerTabs.mobile.scroll.text'
      },
      {
        title: 'viewer-3d-ar.webViewerTabs.mobile.pan.title',
        videoUrl: ViewerMobilePan,
        text: 'viewer-3d-ar.webViewerTabs.mobile.pan.text'
      },
      {
        title: 'viewer-3d-ar.webViewerTabs.mobile.reset.title',
        videoUrl: ViewerMobileReset,
        text: 'viewer-3d-ar.webViewerTabs.mobile.reset.text'
      }
    ]
  }
];

const webViewerCurrentTabId = computed(() => {
  if (userInput.userSelectedTabId !== -1) {
    return userInput.userSelectedTabId;
  }
  if (userInput.mouseHit > userInput.trackpadHit) {
    return 0; // mouse
  }
  if (userInput.trackpadHit === 0 && userInput.isTouch) {
    return 2; // touch
  }
  return 1; // trackpad
});

const localizedImage = computed(() => {
  const images : {[key:string]: any} = {
    en: ThisIsAWeb3DViewer_en,
    it: ThisIsAWeb3DViewer_it,
    de: ThisIsAWeb3DViewer_de,
  }
  return images[locale.value] || images.en
})


// Lifecycle hook to initialize things on mount
onMounted(() => {
  if ('ontouchstart' in window) {
    userInput.isTouch = true;
  }

  document.addEventListener('mousewheel', detectTrackPad, { passive: false });
  document.addEventListener('DOMMouseScroll', detectTrackPad, { passive: false });
});

// Methods
function platformSelected(e: Event) {
  userInput.userSelectedTabId = +(e.target as HTMLSelectElement).value;
}

function detectTrackPad(e: any) {
  let isTrackpad = false;
  if (e.wheelDeltaY) {
    isTrackpad = e.wheelDeltaY === e.deltaY * -3;
  } else if (e.deltaMode === 0) {
    isTrackpad = true;
  }
  if (isTrackpad) {
    userInput.trackpadHit++;
  } else {
    userInput.mouseHit++;
  }
}

// function startHotjar() {
//   if (!hotjarStarted.value) {
//     const hotjarId = env?.VUE_APP_HOTJAR_ID;
//     (function (h, o, t, j, _a, _r) {
//       h.hj = h.hj || function () {
//         (h.hj.q = h.hj.q || []).push(arguments);
//       };
//       h._hjSettings = { hjid: hotjarId, hjsv: 6 };
//       const a = o.getElementsByTagName('head')[0];
//       const r = o.createElement('script');
//       r.async = true;
//       r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
//       a.appendChild(r);
//     })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
//   }
// }
</script>

<style scoped>
.hero {
  background-image: url("~/assets/img/viewer-hero.webp");
}

* {
  scroll-behavior: smooth
}

input[type=checkbox] {
  @apply ml-4
}

p {
  @apply laptop:text-slg md:text-base leading-7
}
p:not(:first-child) {
  margin-top: 1em;
}

.webp .sketched-bkg {
  background-image: url("~/assets/img/landing/sketchedbkg.webp");
  background-size: 100% 100%;
}
.no-webp .sketched-bkg {
  background-image: url("~/assets/img/landing/sketchedbkg.jpg");
  background-size: 100% 100%;
}

h3 {
  @apply text-3xl font-bold mt-2
}

ul {
  @apply list-disc list-inside pl-4 laptop:text-slg md:text-base
}

.font-smaller {
  font-size: 70%;
  @apply text-standard
  /* @apply text-highlight */
}

@media (max-width: 1279px) {
  .viewer3d {
    max-height: 70vh !important;
    min-height: unset !important;
  }
}
</style>
